// 准备state--用于存储数据
import axios from 'axios'
const state = {
  aiList: []
}
// actions异步请求处理
const actions = {
  getAllList(context) {
    // vuex中this的指向是store，因此不能使用,直接引入axios请求即可
    axios.get('/aigenai/allAi/getAllList').then(
      res => {
        if (res.data.code !== 0) {return}
        context.commit('UPDATE_AI_LIST', res.data.data)
      }
    ).catch(err=>{console.log('err', err)})
  },
}
// mutations主要用来操作(state)
const mutations = {
  UPDATE_AI_LIST(state, data){
    state.aiList = []
    state.aiList.push(...data)
  }
}

export default {
  state,
  actions,
  mutations
}